import React, {useEffect, useState} from "react";
import EmailInput, {InitialEmailState} from "../Inputs/EmailInput";
import {isAllTrue} from "../../utils/validators";


export default function MailchimpSignupForm(props) {
  const [email, setEmail] = useState(InitialEmailState);
  const [disabledForm, setDisabledForm] = useState(true);

  useEffect(() => {
    const isEmailValid = isAllTrue(email.validators);
    const isEmailNotEmpty = email.value !== "";
    setDisabledForm(!(isEmailValid && isEmailNotEmpty));
  }, [email]);

  return (
    <>
      <form
        action="https://poker.us14.list-manage.com/subscribe/post?u=8601bc38c20958e388049dade&amp;id=2b92fbead1&amp;f_id=0015d3e1f0"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className={`validate z-[10000] w-full  ${props.formClassName ?? ""} `}
        target="_blank"
        noValidate
      >
        <div className={`flex w-full justify-center text-center items-center  ${props.divClassName ?? ""}`}>
            <div className={`flex flex-row relative ${props.divBtnClassName ?? ""} `}>
              <input
                type="submit"
                value="Submit"
                name="subscribe"
                id="mc-embedded-subscribe"
                disabled={disabledForm}
                className={`flex button rounded-lg text-[12px] lg:text-xs button-text items-center justify-center disabled:cursor-not-allowed btn-blue disabled:btn-blue-disabled ${props.btnClassName ?? ""}`}
              />
            </div>
            <EmailInput
              inputClassName={`bg-[#ECECEC]  placeholder:text-center border-radius-12px text-black ${props.inputClassName ?? ""} `}
              email={email}
              setEmail={setEmail}
              isRequired={true}
              validEmail={true}
              showErrorBelowInput={true}
              label={`${props.label ?? ""}`}
              labelClassName="w-full welcome-screen-subtitle  justify-center text-[14px] "
              placeholder={"your@email.com"}
              name="EMAIL"
              errorsClassName={`${props.errorsClassName ?? ""}`}
              checkIcon={props.checkIcon ?? false}
            />
            {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
            <div style={{position: "absolute", left: "-5000px"}} aria-hidden="true">
              <input
                type="text"
                name="b_8601bc38c20958e388049dade_2b92fbead1"
                tabIndex="-1"
                defaultValue=""
              />
            </div>
        </div>
      </form>
      <script
        type="text/javascript"
        src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
      ></script>
      <script type="text/javascript">
        {`(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='COUNTRY';ftypes[1]='dropdown';}(jQuery));var $mcj = jQuery.noConflict(true);`}
      </script>
    </>
  )
}
;
